<main>
    <section class="about-us-section">
      <div class="container">
        <h1 class="main-title">CAMBEN: Fábrica Líder de Uniformes Oficiales Adventistas con 40 Años de Trayectoria | Envíos Nacionales e Internacionales</h1>
        
        <section class="featured-video-section mb-5" itemscope itemtype="https://schema.org/VideoObject">
          <h2 class="sub-title">Conoce la Calidad de Nuestros Uniformes Adventistas: Guías Mayores, Conquistadores y Aventureros</h2>
          <div class="main-video-container">
            <iframe 
              src="https://www.youtube.com/embed/1PSQDsAzBZs" 
              title="CAMBEN: Uniforme Oficial del Club de Guías Mayores y Conquistadores - Envíos a todo el mundo" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
            </iframe>
            <meta itemprop="name" content="Uniformes Oficiales Guías Mayores y Conquistadores | CAMBEN">
            <meta itemprop="description" content="Descubre la calidad de fabricación 100% mexicana en los uniformes para los Ministerios Juveniles de la Iglesia Adventista del Séptimo Día.">
          </div>
        </section>
  
        <div class="content-block">
          <p class="intro-text">
            Somos <strong>CAMBEN</strong>, una empresa 100% mexicana con **más de 40 años de trayectoria** en la industria textil. Fundada como marca en 2018, nuestra visión se basa en crear **soluciones textiles de alta calidad** y durabilidad. Desde nuestros orígenes, nos hemos consolidado como una **fábrica de ropa especializada** con la experiencia necesaria para la confección de uniformes duraderos y funcionales.
          </p>
          <p class="intro-text">
            Nos enorgullece ser la **empresa pionera en innovar y modernizar la experiencia de compra** para los **Ministerios Juveniles** en México. Ofrecemos la **tienda en línea más completa y segura**, especializada en **todo el material oficial** de los clubes: **Guías Mayores, Conquistadores y Aventureros**.
          </p>
          <p class="intro-text highlight-seo">
            **Nuestra Promesa:** Buscamos facilitarle la vida a los líderes de los clubes de la **Iglesia Adventista del Séptimo Día**. Por ello, ofrecemos **TODOS los uniformes y accesorios en un solo lugar** (*one-stop shop*), con **Envío GRATIS** en pedidos calificados dentro de México y con la capacidad de realizar **Envíos Internacionales** a cualquier parte del mundo. ¡Calidad mexicana con alcance global respaldada por cuatro décadas de experiencia!
          </p>
        </div>
  
        <div class="production-lines">
          <h2 class="sub-title">Nuestra Especialización: Catálogo Completo y Material Oficial</h2>
  
          <article class="line-item" itemprop="knowsAbout" itemscope itemtype="https://schema.org/Product">
            <h3 class="line-title" itemprop="name">Uniformes y Accesorios Oficiales del Club de Conquistadores, Guías Mayores y Aventureros</h3>
            <p>
              Somos **fabricantes expertos en uniformes adventistas**, garantizando que cada pieza (camisas, pantalones, pañoletas, **insignias oficiales**, etc.) cumpla estrictamente con los **estándares de calidad y las especificaciones oficiales** de la División Interamericana (DIA). Al elegir **CAMBEN**, usted adquiere un producto que apoya la identidad y el **crecimiento de su Club**. Somos su fuente única para todo el material necesario de los **clubes de Conquistadores y Aventureros**.
            </p>
            <meta itemprop="category" content="Uniformes Juveniles Adventistas y One-Stop Shop">
          </article>
  
          <article class="line-item">
            <h3 class="line-title">Ropa Casual, Juvenil y Telas Sustentables</h3>
            <p>
              Hemos desarrollado una línea de **ropa casual moderna y cómoda**, utilizando **telas sustentables** y procesos de fabricación conscientes con el medio ambiente.
            </p>
          </article>
        </div>
  
        <div class="closing-statement">
          
          <!--section class="testimonials-section mb-5">
            <h2 class="sub-title">Nuestra Confianza: Testimonios de Clubes y Líderes</h2>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="card p-3 shadow-sm h-100 text-left">
                  <p class="font-italic">"La calidad de las telas es inigualable. Los uniformes de mis Guías Mayores lucen perfectos en cada investidura. ¡Felicidades por su servicio y experiencia!"</p>
                  <footer class="blockquote-footer mt-2">Líder Gaby R. <cite title="Club Conquistadores México">Club Águilas de Fuego</cite></footer>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="card p-3 shadow-sm h-100 text-left">
                  <p class="font-italic">"Necesitaba varios uniformes y accesorios urgentes. El servicio de entrega y la atención de CAMBEN fue excelente. ¡Los recomiendo ampliamente!"</p>
                  <footer class="blockquote-footer mt-2">Pr. Samuel T. <cite title="Ministerio Juvenil">Iglesia Central, Monterrey</cite></footer>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4 d-none d-lg-block">
                <div class="card p-3 shadow-sm h-100 text-left">
                  <p class="font-italic">"Tener todos los parches y el uniforme en un solo lugar nos ahorró mucho tiempo. La calidad 100% mexicana se siente en la durabilidad."</p>
                  <footer class="blockquote-footer mt-2">María F. <cite title="Club Aventureros">Líder de Aventureros, Tabasco</cite></footer>
                </div>
              </div>
            </div>
          </section-->
          <div class="card">
            <div class="card-body">
              <p class="card-text">
                En **CAMBEN**, cada prenda es un reflejo de nuestra pasión por la calidad, el diseño y nuestro **compromiso global**. Te ofrecemos la **confiabilidad y seguridad** en cada compra de uniformes **con Envío Gratis en México y Envíos Internacionales disponibles**. Nuestra meta es ofrecer productos que visten y cuentan una historia de dedicación y servicio.
              </p>
            </div>
          </div>

          <section class="contact-info mt-5" itemprop="hasPart" itemscope itemtype="https://schema.org/ContactPoint">
            <h2 class="sub-title">¡Contáctanos! Su Proveedor de Uniformes con Alcance Mundial</h2>
            <address>
              **Dirección de Fábrica/Oficina Principal:** Juárez, Nuevo León, México
              <span itemprop="telephone">Teléfono: +528110760979</span> 
              <span itemprop="email">Email: camben.elegance&#64;gmail.com</span>
            </address>
          </section>
  
          <div class="social-section mt-5">
            <h3>Síguenos en nuestras redes sociales</h3>
            <p>Únete a nuestra comunidad para estar al tanto de las últimas novedades, promociones y lanzamientos.</p>
            <div class="social-icons d-flex justify-content-center gap-3">
              <a [href]="facebookUrl" target="_blank" rel="noopener noreferrer" class="social-link">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a [href]="tiktokUrl" target="_blank" rel="noopener noreferrer" class="social-link">
                <i class="fab fa-tiktok"></i>
              </a>
              <a [href]="youtubeUrl" target="_blank" rel="noopener noreferrer" class="social-link">
                <i class="fab fa-youtube"></i>
              </a>
              <a [href]="linkedinUrl" target="_blank" rel="noopener noreferrer" class="social-link">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
  
          <section class="social-previews mt-5">
            <h2 class="sub-title">Descubre nuestros productos en YouTube: Tutoriales y Calidad CAMBEN</h2>
            <div class="row">
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/DI_r1yDJ57s" title="Tutorial de Colocación de Parches y Uniforme de Gala Guía Mayor CAMBEN" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/yrJqdvPuGoY" title="Uniformes Oficiales Conquistadores CAMBEN: Calidad de Fábrica y Diseño" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/Ej8W6qISEIM" title="Nuevas Camisetas Deportivas para Club de Aventureros" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/wtiP0riHQDo" title="Envíos de Uniformes CAMBEN: Cómo Empacamos tus Pedidos" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/tdYWnGLYSps" title="Resumen de Telas y Materiales de los Uniformes Adventistas" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/LWElmevodHk" title="Video de Producto: Pantalón de Conquistador Oficial" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/iEkF7_em2HY" title="Video de Producto: Camisa de Guía Mayor de Alta Durabilidad" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/tvPRGuwa0lg" title="Lanzamiento: Nuevas Pañoletas y Sujetadores Oficiales CAMBEN" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/gRpghwzRXZQ" title="Video de Producto: Faldas y Blusas de Aventureros y Conquistadoras" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/RkSibRelZ6M" title="Día de la Fábrica CAMBEN: Confeccionando Uniformes Adventistas" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/g-NhOg5Qum4" title="Reseña de Clientes: Uniformes CAMBEN para el Camporee Nacional" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 mb-4">
                <div class="video-container">
                  <iframe src="https://www.youtube.com/embed/_cXha-a-Ug4" title="Video de Producto: Conjuntos de Ropa Casual Juvenil CAMBEN" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </section>
  
          </div>
      </div>
    </section>
  </main>